import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./msalConfig";

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MsalProvider>
  );
};

msalInstance.initialize().then(() => {
 
  msalInstance.handleRedirectPromise()
    .then(renderApp)
    .catch((err) => {
      console.error("Redirect error:", err);
      renderApp();
    });
});

reportWebVitals();